import { render, staticRenderFns } from "./form-required-note.vue?vue&type=template&id=12799f27"
import script from "./form-required-note.vue?vue&type=script&lang=js"
export * from "./form-required-note.vue?vue&type=script&lang=js"
import style0 from "./form-required-note.vue?vue&type=style&index=0&id=12799f27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports